<ion-grid>
  <ion-row>
    <ion-col>
      <div class="login-wrapper">
        <ion-col size-xs="20" size-sm="15" class="login-intro">
          <div class="mu-logo-container">
            <mu-university-logo
              [variant]="'full'"
              [color]="'dark'"
            ></mu-university-logo>
          </div>
          <h2 class="ion-text-center">
            {{ 'login-page.welcome.title' | translate }}
          </h2>
          <p class="ion-text-center"></p>
        </ion-col>
        <div *ngIf="allowDevLogin()" class="mu-input-container mu-px3">
          <input
            class="mu-input-field"
            #devInput
            type="text"
            placeholder="Enter a participant ID: I0000000 (only for non-production envs)"
            aria-placeholder="Enter a participant ID"
          />
        </div>
        <ion-col size-xs="20" size-sm="15">
          <mu-button
            class="sign-in-button"
            label="Sign in"
            (buttonClick)="signIn()"
            >{{ 'login-page.signin' | translate }}</mu-button
          >
          <div *ngIf="errorLogMessage" class="maintenance">
            <span [innerHTML]="'login-page.error-message' | translate">
            </span>
            <a href="{{serviceDeskPage}}"target="_blank">{{'elements.servicedesk' | translate}}</a>.
          </div>
          <div *ngIf="loginMessage" class="maintenance">
            <p [innerHTML]="loginMessage" class="ion-text-center"></p>
          </div>
          <div *ngIf="maintenance || maintenanceMessage!='-'" class="maintenance">
            <h2 class="ion-text-center">
              {{ 'login-page.maintenance.title' | translate }}
            </h2>
            <p class="ion-text-center">
              {{ maintenanceMessage }}
            </p>
          </div>
        </ion-col>
        <mu-dots class="mu-dots" direction="vertical"></mu-dots>
      </div>
    </ion-col>
    <ion-col class="ion-hide-md-down" sizeMd="14">
      <ion-img
        class="object-fit-cover ion-hide-md-down"
        src="assets/omslag_compressed.jpg"
      ></ion-img>
    </ion-col>
  </ion-row>
</ion-grid>
